module.exports = __webpack_public_path__ + "img/pc-bottom.b59742b8.webp";